export const smoothScroll = selector => {
	const element = document.querySelector(selector);
	if (element) {
		element.scrollIntoView({
			behavior: 'smooth'
		});
	}
};
